import {SimpleCompany} from '../../companies/SimpleCompany';
import {SimpleWorkspaceUser} from './SimpleWorkspaceUser';
import {Attachment} from '../../Attachment';
import {WorkspaceUserWithAvatar} from '../interfaces/WorkspaceUserWithAvatar';

/** elements are models used in lists **/
export class SimpleWorkspaceUserListElement extends SimpleWorkspaceUser implements WorkspaceUserWithAvatar {
  public companies: Array<SimpleCompany>;
}
